import React from 'react';
import { render } from 'react-dom';

//other components built
import Badge from '../../../../badges/Badge';
import GridColumn from '../../../../services/GridColumn'; //builds ag-grid columns
import UrlSniffer from '../../../../services/UrlSniffer'; //work with rails paths to get project token

//react reveal for to reveal components and validations
import Bounce from 'react-reveal/Fade';

//filters
import DockRenderer from '../../../../filters/DockRenderer';
import FilterQuickAction from '../../../../filters/FilterQuickAction'; //filter controls

//forms
import { AutoComplete, Input, InputNumber, Checkbox, Slider, Row, Col } from 'antd';
import Select from 'react-select'; //select box for filter

import ReactDom from 'react-dom';

//ag grid
import GridRenderer from '../../../../grids/GridRenderer';

//http requests
import axios from 'axios';

//state
import { decorate, observable, computed, action } from 'mobx';
import { observer } from 'mobx-react';

//router
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

//utility
import { zeroNull, deleteIfEmpty, extractToken, newJsonFieldSchema } from '../../../../services/Utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const _ = require('lodash'); //extra utilities

// Making Instance of class > it's object now
const gridColumns = new GridColumn();
const urlSniffer = new UrlSniffer();

class GlobalUser extends React.Component {
  projectId = extractToken(window.location.pathname, '/', 3);
  mobxState = {
    formState: {
      email: null,
      first_name: null,
      last_name: null,
      permission: null,
    },
    formValid: false,
    showHelperIcons: false,
    submitMessage: false,
    tableData: [],
    //columnDefsUsers: []
  };

  //mount data through http requests
  componentDidMount() {
    //call the data loader to load data into the view
    this.fetchData();
  };

  //////////////////HTTP/////////////////
  //data loader
  fetchData = () => {
    //quick workaround -- pull simple dropdown value from nested component instead of passing around state
    var table_rows = window.$('#table_rows_dropdown').val();

    //include any custom field names not in db
    this.mobxState.customOptions = {
        project__name: 'Project Name'
    };

    //after ag grid is set up, get the rest of the data
    //table data load
    axios
      .post('/v1/global_users_index', table_rows)
      .then(response => {

        this.mobxState.tableData = response.data;

        //set the column definitions for ag grid, look into buildColumnDefs class to see options
        this.mobxState.columnDefsUsers = gridColumns.buildColumnDefs({
          "customOptions": this.mobxState.customOptions,
          "columnArray": ['global_users'],
          "customFieldSchema": {},
          "dataType": 'global_user' //special tag to signify that this is project data
        });

        //autofit the table columns (hits the child function), this runs after the columns were created
        this.autofitChild();
      })
  }; //end fetchData() ///////////////

  handleFormSubmit = () => {
    console.log('Submitting Form');
    let formState = this.mobxState.formState;
    console.log(formState);
    axios
      .post('/v1/global_users/', formState)
      .then(response => {
        console.log(response);
        console.log('Response Status', response.status);
        this.mobxState.submitMessage = true;
        this.fetchData();
        this.mobxState.formValid = false;
        this.mobxState.showHelperIcons = false;
      }).catch(console.log.bind(console)) //error catcher
  }

  //react-select form state handler
  handleFormChange = (field, event) => {
    console.log(event.target.value);
    this.mobxState.formState[field] = event.target.value;
    console.log('formState', this.mobxState.formState);
    //call validationResult
    this.validateForm();
  }

  deleteRequest = (toSendArr) => {
    console.log("IN DELETION");
    axios.post('/v1/global_users/batch_destroy', {"id_set": toSendArr})
    .then((response) => {
      console.log(response);
      this.fetchData();
    });
  }

  validateForm = () => {
    //email regex
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    //just check that all form variables have a value
    if(
      this.mobxState.formState.email != null
      &&
      re.test(this.mobxState.formState.email.toLowerCase())
      &&
      this.mobxState.formState.first_name != null
      &&
      this.mobxState.formState.last_name != null
    ){
      console.log('Form validated');
      this.mobxState.formValid = true;
      this.mobxState.showHelperIcons = true;
    }else{
      console.log('Form failed valitation');
      this.mobxState.formValid = false;
      this.mobxState.showHelperIcons = false;
    };
  }
  //////////////////END HTTP/////////////////

  render() {

    return (
      <div>

				<div className="jumbotron jumbotron_full_width" style={{maxHeight: '71.5px', overflow: 'visible', whiteSpace: 'nowrap'}}>
					<div className="jumbotron_full_width_container">
            <div className="row">
              <div className="col-sm-5">
                <span className="fa-layers fa-fw fa-2x">
                  <FontAwesomeIcon icon={['fas', 'circle']} transform="grow-3" color="#53C8C5" style={{marginTop: '4px'}} />
                  <FontAwesomeIcon icon={['fas', 'user-circle']} color="white" transform="shrink-5" style={{marginTop: '3px'}} />
                </span>
                &nbsp;
                <b className="dash_header">Manage Users</b>
              </div>
			        <div className="col-sm-2"></div>
			        <div className="col-sm-2"></div>
			        <div className="col-sm-3 gps">
			          <FontAwesomeIcon
			            icon={["fad", "location-arrow"]}
			            color="#53C8C5"
			            transform="grow-15 left-10"
			            style={{}}
			          />
			          <Link to={"/sourcing/projects/"}>
			            Next: Manage Projects
			          </Link>
			        </div>
            </div>
					</div>
				</div>

				{/* PROJECT FORM */}
				<div className="row">
					<div className="col-sm-12">
						<div className="panel panel-default">
							<div className="panel-heading panel_bg clearfix">
									<b>User Creation</b>
									<span className="pull-right">

										<Bounce left when={this.mobxState.submitMessage}>
											<b className="text-success" style={{marginRight: '1.5em',marginTop: '4px'}}>
											  User Created
											</b>
							  		</Bounce>
										<Bounce left when={this.mobxState.showHelperIcons}>
											<span>
												<FontAwesomeIcon icon={['fad', 'long-arrow-alt-right']} size='2x' transform="down-3 grow-10" color="#53C8C5" style={{marginRight:'15px'}}/>
											</span>
										</Bounce>

										<button type="button" disabled={!this.mobxState.formValid} className="btn btn-primary btn-md" onClick={this.handleFormSubmit}>
											<FontAwesomeIcon icon={['fas', 'plus']} />&nbsp; Add User
										</button>
									</span>
							</div>
							<div className="panel-body">

                <form>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className={'top_panel_info'}>Enter user info below and press "Add User" to create user in the system</div>
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-sm-3">
                      <b>User Email</b>
  										<Input name="email" placeholder="Enter email" className="form-control" onChange={(e) => this.handleFormChange('email', e)}/>
                    </div>
                    <div className="col-sm-3">
                      <b>First Name</b>
                      <Input name="first_name" placeholder="Enter name" className="form-control" onChange={(e) => this.handleFormChange('first_name', e)}/>
                    </div>
                    <div className="col-sm-3">
                      <b>Last Name</b>
                      <Input name="last_name" placeholder="Enter last name" className="form-control" onChange={(e) => this.handleFormChange('last_name', e)}/>
                    </div>
                    <div className="col-sm-3">
                      <b>Permission</b>
                      <Input name="last_name" placeholder="Enter permission" className="form-control" onChange={(e) => this.handleFormChange('permission', e)}/>
                    </div>
                  </div>

                </form>

							</div>
						</div>
					</div>{/* END col-sm-12*/}
				</div>{/* END row*/}
				{/* END ITEM FORM*/}

        {/* PROJECT GRID */}
        <div className="row">
          <div className="col-lg-12">
            {/* AG Grid */}
            <GridRenderer
              gridHeight={"650px"}
              columnDefs={this.mobxState.columnDefsUsers}
              rowData={this.mobxState.tableData.global_users}

              fetchData={this.fetchData}
              handleClear={this.handleClear}
              toggleDock={this.toggleDock}
              pageId={9}

              savedState={this.mobxState.pivotState}
              isPivotMode={true}
              gridTitle={"Global User Details"}

              setClick={click => this.clickChild = click}

              deleteRequest={this.deleteRequest}
              idColumn={"id"}

              modelsToUpdateArr={[{url:'v1/global_users/', idName:'id'}]}
              //modelsToUpdateArr={false}
              enableSetResizeChild={true}
              setResize={click => this.autofitChild = click}
              // enableSetResizeChildColumns={true}
              // setResizeToColumnWidth={click => this.autofitChildToColumnWidth = click}

              singleClickEdit={true}
              suppressClickEdit={false}

              isSaveable={false}
              isAwardable={false}
              isDeletable={true}
            />

          </div>
        </div>{/* END GRID ROW */}

      </div>
    );
  }
}

// when using decorate, all fields should be specified (a class might have many more non-observable internal fields after all)
decorate(GlobalUser, {
  mobxState: observable
});

export default observer(GlobalUser);

// export default ProjectOverview;
